import {ChangeDetectionStrategy, Component, effect, inject, input, signal, WritableSignal} from '@angular/core';

import {ProductCarouselComponent} from '@layout/components/product/product-carousel/product-carousel.component';
import {ProductWidgetComponent} from '@layout/components/product/product-widget/product-widget.component';
import {AlgoliaRecommendService} from '@core/services/algolia-recommend.service';
import {AlgoliaService} from '@core/services/algolia.service';
import {AlgoliaWineProduct} from '@core/types/algolia-wine-product';

@Component({
  selector: 'app-product-trending-items',
  templateUrl: './product-trending-items.component.html',
  styleUrls: ['./product-trending-items.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ProductCarouselComponent,
    ProductWidgetComponent,
  ]
})
export class ProductTrendingItemsComponent {
  protected algoliaService = inject(AlgoliaService);
  private algoliaRecommendService = inject(AlgoliaRecommendService);


  trendingItems: WritableSignal<AlgoliaWineProduct[]> = signal([]);

  facetName = input<string | undefined>();
  facetValue = input<string | undefined>();
  maxRecommendations = input<number>(9);
  layout = input<'carousel' | 'grid'>('carousel');

  constructor() {
    effect(async () => {
      const algoliaSettings = this.algoliaService.algoliaSettings();
      if (!algoliaSettings) {
        return;
      }

      const maxRecommendations = this.maxRecommendations();
      const facetName = this.facetName();
      const facetValue = this.facetValue();

      this.trendingItems.set(await this.algoliaRecommendService.getTrendingProducts(algoliaSettings, maxRecommendations, '', facetName, facetValue));
    });
  }
}
